export const COMMAND_LIST = [
  { name: "help", description: "ヘルプ" },
  { name: "whoami", description: "わ　た　し　で　す　＾o＾　" },
  { name: "history", description: "履歴" },
  { name: "jobs", description: "職務経歴" },
  { name: "tail /var/log/messages", description: "ログ" },
]